import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { FormFiltersInterface } from "../interfaces/FormFiltersInterface";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { McmEmpresaCobranza } from "../models/respuestaMorososServinco";

const obtenerEmpresasCobranza = async () => {
    const response: Promise<AxiosResponse<ListResponseDto<McmEmpresaCobranza>>> = axiosInstance.get("siscred-api-transversal/v1/instituciones/mcm_empresa_cobranza");
    return response;
}

const grabarEmpresaCobranza = async (formFilters: FormFiltersInterface, idEmpresaCobranza: string, ids: number[]) => {
    const body = {
        rutDeudor: formFilters.rutDeudor ? formFilters.rutDeudor : null,
        nombreDeudor: formFilters.nombreDeudor ? formFilters.nombreDeudor : null,
        numeroOperacion: formFilters.numeroOperacion ? formFilters.numeroOperacion : null,
        rutEmisor: formFilters.rutEmisor == "0" ? null : formFilters.rutEmisor,
        isAdmin: formFilters.isAdmin,
        empresaId: idEmpresaCobranza ? idEmpresaCobranza : null,
        idsMarcar: ids
    };

    const response: Promise<any> = axiosInstance.post(`siscred-api-cartera-total/v1/morosos/marcar-desmarcar`, body);
    return response;
}

export {
    obtenerEmpresasCobranza,
    grabarEmpresaCobranza,
};